import Vue from "vue";

const YesNoValue = Vue.filter('yesNoValue', function (value) {
  return value ? 'client.client_card.value.yes_true' : 'client.client_card.value.no_false';
});

export default {
  YesNoValue
};
